exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".insurance-banner-container{box-shadow:0 1px 10px 0px #e3e3e3;border-radius:8px;overflow:hidden;cursor:pointer}.insurance-banner-container .insurance-banner{width:auto;max-width:-webkit-fill-available}\n", ""]);

